<!-- Meeting Notes Container -->
<div class="meeting-notes-container">

  <!-- Add Meeting Note Section -->
  <div class="section-header">
    <h2 class="section-title">Add Meeting Notes</h2>
  </div>

  <div class="meeting-card">
    <!-- Date, Title and Attendees Row -->
    <div class="card-row three-column-row">
      <div class="date-chip-container">
        <span class="calendar-icon">📅</span>
        <input 
          type="date" 
          [(ngModel)]="newMeetingNote.date"
          (change)="markNewNoteChanged()"
          [max]="maxDate"
          class="date-input"
          placeholder="Select Date">
      </div>

      <div class="heading-container">
        <input 
          type="text" 
          [(ngModel)]="newMeetingNote.heading"
          (input)="markNewNoteChanged()"
          placeholder="Enter meeting title"
          class="heading-input">
      </div>

      <div class="attendees-container">
        <label class="field-label">Attendees:</label>
        <input 
          type="text" 
          [(ngModel)]="newMeetingNote.attendees"
          (input)="markNewNoteChanged()"
          placeholder="Add Here"
          class="field-input">
      </div>
    </div>

    <!-- Key Topics Section -->
    <div class="card-section">
      <label class="field-label">Key Topics</label>
      <input 
        type="text" 
        [(ngModel)]="newKeyTopic"
        (keyup.enter)="addKeyTopicToNew()"
        placeholder="Type Here & Enter"
        class="field-input">
      <div class="topics-chips">
        <span 
          *ngFor="let topic of newMeetingNote.keyTopics; let i = index" 
          class="topic-chip">
          {{topic}}
          <button class="remove-chip-btn" (click)="removeKeyTopicFromNew(i)">×</button>
        </span>
      </div>
    </div>

    <!-- Notes Section -->
    <div class="card-section">
      <label class="field-label">Notes:</label>
      <textarea 
        [(ngModel)]="newMeetingNote.notes"
        (input)="markNewNoteChanged()"
        placeholder="Enter your notes here..."
        class="notes-textarea"
        rows="6"></textarea>
    </div>

    <!-- Action Items Section -->
    <div class="card-section">
      <label class="field-label">Action Items:</label>
      <div class="action-items-box">
        <div 
          *ngFor="let item of newMeetingNote.actionItems; let i = index; trackBy: trackByIndex" 
          class="action-item-row">
          <span class="action-number">{{i + 1}}.</span>
          <input 
            type="text" 
            [(ngModel)]="newMeetingNote.actionItems[i]"
            (input)="markNewNoteChanged()"
            placeholder="Enter action item"
            class="action-input">
          <button 
            *ngIf="newMeetingNote.actionItems.length > 1"
            class="remove-action-btn" 
            (click)="removeActionItemFromNew(i)">×</button>
        </div>
        <button class="add-action-link" (click)="addActionItemToNew()">+ Add Action Item</button>
      </div>
    </div>

    <!-- Footer Buttons -->
    <div class="card-footer">
      <button 
        class="btn-save"
        [ngClass]="{'btn-save-active': newMeetingNote.hasChanges}"
        (click)="saveNewMeetingNote()">
        Save Changes
      </button>
    </div>
  </div>

  <!-- Previous Meeting Notes Section -->
  <div class="section-header-with-search">
    <h2 class="section-title">Previous Meeting Notes</h2>
    <div class="search-date-container">
      <label class="search-label">Search Notes</label>
      <div class="date-picker-wrapper">
        <span class="calendar-icon-small">📅</span>
        <input 
          type="date" 
          [(ngModel)]="searchDate"
          (change)="searchByDate()"
          class="date-picker">
        <button 
          *ngIf="searchDate"
          class="clear-search-btn" 
          (click)="clearSearch()">×</button>
      </div>
    </div>
  </div>

  <!-- Previous Meeting Notes Cards -->
  <div class="previous-notes-container">
    <div 
      *ngFor="let note of previousMeetingNotes" 
      class="meeting-card">
      
      <!-- Date, Title and Attendees Row -->
      <div class="card-row three-column-row">
        <div class="date-chip-container">
          <span class="calendar-icon">📅</span>
          <input 
            *ngIf="note.isEditing"
            type="date" 
            [(ngModel)]="note.date"
            (change)="markNoteChanged(note)"
            [max]="maxDate"
            class="date-input">
          <span 
            *ngIf="!note.isEditing"
            class="date-chip">
            {{formatDate(note.date)}}
          </span>
        </div>

        <div class="heading-container">
          <input 
            *ngIf="note.isEditing"
            type="text" 
            [(ngModel)]="note.heading"
            (input)="markNoteChanged(note)"
            placeholder="Enter meeting title"
            class="heading-input">
          <span 
            *ngIf="!note.isEditing && note.heading"
            class="heading-chip">
            {{note.heading}}
          </span>
        </div>

        <div class="attendees-container">
          <label class="field-label">Attendees:</label>
          <input 
            type="text" 
            [(ngModel)]="note.attendees"
            (input)="markNoteChanged(note)"
            [readonly]="!note.isEditing"
            class="field-input"
            [ngClass]="{'readonly': !note.isEditing}">
        </div>
      </div>

      <!-- Created By / Created Date Row (shown before Key Topics) -->
      <div 
        class="card-section created-meta-row"
        *ngIf="note.createdBy || note.createdDate">
        <div class="created-meta-item" *ngIf="note.createdBy">
          <span class="field-label">Created By:</span>
          <span class="meta-text">{{ note.createdBy }}</span>
        </div>
        <div class="created-meta-item" *ngIf="note.createdDate">
          <span class="field-label">Created Date:</span>
          <span class="meta-text">{{ formatDate(note.createdDate) }}</span>
        </div>
      </div>

      <!-- Key Topics Section -->
      <div class="card-section">
        <label class="field-label">Key Topics</label>
        <input 
          *ngIf="note.isEditing"
          type="text" 
          [(ngModel)]="getTempInput(note.id).keyTopic"
          (keyup.enter)="addKeyTopicToNote(note)"
          placeholder="Type Here & Enter"
          class="field-input">
        <div class="topics-chips">
          <span 
            *ngFor="let topic of note.keyTopics; let i = index" 
            class="topic-chip">
            {{topic}}
            <button 
              *ngIf="note.isEditing"
              class="remove-chip-btn" 
              (click)="removeKeyTopicFromNote(note, i)">×</button>
          </span>
        </div>
      </div>

      <!-- Notes Section -->
      <div class="card-section">
        <label class="field-label">Notes:</label>
        <textarea 
          [(ngModel)]="note.notes"
          (input)="markNoteChanged(note)"
          [readonly]="!note.isEditing"
          class="notes-textarea"
          [ngClass]="{'readonly': !note.isEditing}"
          rows="6"></textarea>
      </div>

      <!-- Action Items Section -->
      <div class="card-section">
        <label class="field-label">Action Items:</label>
        <div class="action-items-box">
          <div 
            *ngFor="let item of note.actionItems; let i = index; trackBy: trackByIndex" 
            class="action-item-row">
            <span class="action-number">{{i + 1}}.</span>
            <input 
              *ngIf="note.isEditing"
              type="text" 
              [(ngModel)]="note.actionItems[i]"
              (input)="markNoteChanged(note)"
              placeholder="Enter action item"
              class="action-input">
            <span 
              *ngIf="!note.isEditing"
              class="action-text">{{item}}</span>
            <button 
              *ngIf="note.isEditing && note.actionItems.length > 1"
              class="remove-action-btn" 
              (click)="removeActionItemFromNote(note, i)">×</button>
          </div>
          <button 
            *ngIf="note.isEditing"
            class="add-action-link" 
            (click)="addActionItemToNote(note)">+ Add Action Item</button>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="card-footer">
        <button 
          class="btn-delete" 
          (click)="deleteNote(note)">
          Delete Notes
        </button>
        <button 
          *ngIf="!note.isEditing"
          class="btn-edit" 
          (click)="enableEdit(note)">
          Edit Notes
        </button>
        <button 
          *ngIf="note.isEditing"
          class="btn-cancel" 
          (click)="cancelEdit(note)">
          Cancel
        </button>
        <button 
          class="btn-save"
          [ngClass]="{'btn-save-active': note.isEditing && note.hasChanges}"
          [disabled]="!note.hasChanges"
          (click)="saveChanges(note)">
          Save Changes
        </button>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="previousMeetingNotes.length === 0" class="empty-state">
      <p>No meeting notes found.</p>
    </div>
  </div>

</div>

